import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { myApi, TOKEN_KEY } from "./redux/api";
import { useMeQuery } from "./redux/adminApi";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const { data: me, isLoading, isError } = useMeQuery(undefined, { skip: !token });

  const logout = useCallback(
    (message) => {
      localStorage.removeItem(TOKEN_KEY);
      setToken(null);
      dispatch(myApi.util.resetApiState());
      if (message) toast.info(message);
    },
    [dispatch]
  );
  const login = (t) => {
    localStorage.setItem(TOKEN_KEY, t);
    setToken(t);
  };

  useEffect(() => {
    const onExpired = () => logout("Your session has ended. Please sign in again.");
    window.addEventListener("admin:session-expired", onExpired);
    return () => window.removeEventListener("admin:session-expired", onExpired);
  }, [logout]);
  useEffect(() => {
    if (isError) logout();
  }, [isError, logout]);

  const can = (...perms) => Boolean(me && (me.is_owner || perms.some((p) => me.permissions.includes(p))));
  return (
    <AuthContext.Provider value={{ token, me, loading: Boolean(token) && isLoading, authenticated: Boolean(token && me), login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
};
